import {
  Button,
  LinearProgress,
  Stack,
} from '@mui/material';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import React, { useState } from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { GetPatientById } from '../../Adapters/GetPatientById';
import PatientBox from '../PatientBox/PatientBox';

const PatientList = ({
  patients,
  setShowForm,
  setSelectedPatient,
}) => {
  return (
    <React.Fragment>
      <Stack sx={{ mt: '.5em' }} gap=".5em">
        {patients?.map((patient) => (
          <PatientBox
            patient={patient}
            key={patient.IdPatient}
            setShowForm={setShowForm}
            setSelectedPatient={setSelectedPatient}
          />
        ))}
      </Stack>
    </React.Fragment>
  );
};

export default PatientList;
